import { useState } from 'react';
import { FormattedText } from '../FormattedText';
import { previewText } from '../../constants/posts';

/**
 * A yap's text in a feed: long ones are shown collapsed with "See more",
 * which expands in place (and "See less" folds it back). Short ones render
 * exactly as FormattedText did.
 *
 * The toggle stops propagation: feed cards open the detail screen on tap, and
 * tapping "See more" should expand the text, not navigate away.
 */
export function ExpandableText({ text, className }: { text: string; className?: string }) {
  const [expanded, setExpanded] = useState(false);
  const { preview, truncated } = previewText(text || '');

  return (
    <>
      <FormattedText text={expanded || !truncated ? (text || '') : preview} className={className} />
      {truncated && (
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setExpanded((v) => !v); }}
          className="text-[#F39C12] dark:text-[#4478ea] text-sm font-semibold"
          style={{ display: 'block', alignSelf: 'flex-start', marginRight: 'auto', textAlign: 'left', marginTop: 2, marginBottom: 6, padding: 0, background: 'none' }}
          aria-expanded={expanded}
        >
          {expanded ? 'See less' : 'See more'}
        </button>
      )}
    </>
  );
}
